import { useCallback } from "react";
import axios from "../../common/api/HttpClient";

export function useLisaFormatter() {

  const formatValue = useCallback(async(datatype, format, inputValue) => {
    let result = {};

    try {
      const response = await axios({
        method: "get",
        url: "/additional-info-field-formatted-value",
        params: { 
          keDatentyp: datatype,
          format: format,
          wert: inputValue
        }
      });

      if (response.status === 200) {
        result = response.data.data;
      }
    } catch (error) {
      console.error(error);
    }

    return result;
  }, []);

  return {
    formatValue
  }
}